import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import AllProducts from "./components/AllProducts";

function AllProductsIndex() {
  const { t } = useTranslation();
  const headingColor = useColorModeValue("#101A2E", "white");
  const mutedColor = useColorModeValue("#6B7A90", "gray.400");

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Flex direction="column" ps="4px" mb="4px">
        <Text
          color={headingColor}
          fontWeight="700"
          fontSize={{ base: "26px", md: "32px" }}
          letterSpacing="-0.03em"
        >
          {t("common:allProducts.title")}
        </Text>
        <Text fontSize="14px" color={mutedColor} mt="8px">
          {t("common:allProducts.description")}
        </Text>
      </Flex>

      <AllProducts />
    </Flex>
  );
}

export default AllProductsIndex;
